import React, { useState } from "react";
import NeumetricLogoImg from "../../assets/images/neumetric-logo.png";
import ProfilePicImg from "../../assets/images/profile_pic.png";
import Eval404Img from "../../assets/images/404-eval.png";
import LoadingOvalImg from "../../assets/images/Loading_Oval.png";
import LoadingGIFImg from "../../assets/images/Loading.gif";
import LogInOval from "../../assets/images/login-oval.png";
import NoAccessEvalImg from "../../assets/images/no-access.png";
//Icon
import WarningIconImg from "../../assets/images/warning.png";
import CircularBGImg from "../../assets/images/circular-bg.png";
import CSVIconImg from "../../assets/images/csv_icon.png";
import CSVBlueIconImg from "../../assets/images/csv_blue_icon.png";
import PlusIconImg from "../../assets/images/Plus.png";
import ArchiveFolderImg from "../../assets/images/archive-folder.png";
import UploadIconTmg from "../../assets/images/upload_icon.png";
import CloseIconImg from "../../assets/images/close_icon.png";

const getAssetsS3Path = (iFileName) => {
  return `https://nmlogoicon.s3.ap-south-1.amazonaws.com/${iFileName}`;
};
export const getModuleIconLink = (moduleName) => {
  return getAssetsS3Path(`Icon${moduleName}.png`);
};
export const getModuleLogoLink = (moduleName) => {
  return getAssetsS3Path(`Logo${moduleName}.png`);
};
export const LogInOvalImg = (props) => {
  return <img src={LogInOval} {...props} />;
};
export const ProfilePic = (props) => {
  return <img src={ProfilePicImg} {...props} />;
};
export const Eval404 = (props) => {
  return <img src={Eval404Img} {...props} />;
};
export const LoadingOval = (props) => {
  return <img src={LoadingOvalImg} {...props} />;
};
export const LoadingGIF = (props) => {
  return <img src={LoadingGIFImg} {...props} />;
};
//Logos
export const ControllerLogo = (props) => {
  return <img src={getModuleLogoLink("Controller")} {...props} />;
};
//Icons

export const CSVIcon = (props) => {
  return <img src={CSVIconImg} {...props} />;
};
export const CSVBlueIcon = (props) => {
  return <img src={CSVBlueIconImg} {...props} />;
};
export const PlusIcon = (props) => {
  return <img src={PlusIconImg} {...props} />;
};
export const ArchiveFolderIcon = (props) => {
  return <img src={ArchiveFolderImg} {...props} />;
};
export const UploadIcon = (props) => {
  return <img src={UploadIconTmg} {...props} />;
};
export const CloseIcon = (props) => {
  return <img src={CloseIconImg} {...props} />;
};
export const NeumetricLogo = (props) => {
  return <img src={NeumetricLogoImg} {...props} />;
};
export const CompanyLogo = (props) => {
  const { user } = props;
  let [error, setError] = useState(false);
  return (
    <React.Fragment>
      {error ? (
        <NeumetricLogo alt="company Logo" className="company" />
      ) : (
        <img
          src={
            user.logo_url
              ? user.logo_url
              : user.ent_org && user.ent_org.logo_url
                ? user.ent_org.logo_url
                : ""
          }
          alt="company Logo"
          className="company"
          onError={() => setError(true)}
        />
      )}
    </React.Fragment>
  );
};
export const WarningIcon = (props) => {
  return <img src={WarningIconImg} {...props} />;
};
export const NoAccessEval = (props) => {
  return <img src={NoAccessEvalImg} {...props} />;
};
export const CircularBG = (props) => {
  return <img src={CircularBGImg} {...props} />;
};
